import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import type { ITextField } from '@fluentui/react/lib/TextField';
import type { AssetCommonViewProps } from 'owa-timestream-asset-sdk-types';
import { AssetError, AssetErrorType, AssetErrorNotFound } from 'owa-timestream-asset-sdk';
import type { TaskViewPayload } from '../schema';
import SubTasksView from './SubTasksView';
import TaskViewCompletion from './TaskViewCompletion';
import TaskViewTitle from './TaskViewTitle';
import useTaskViewState from '../hooks/useTaskViewState';

export default observer(function TaskView({
    payload,
    isDragPreview,
    DueDate,
}: AssetCommonViewProps<TaskViewPayload>) {
    const newSubtaskRef = React.useRef<ITextField>(null);
    const {
        taskId,
        taskSubject,
        subtasks,
        folderId,
        isTaskComplete,
        errorType,
        hasLocalTaskSubject,
        disableSubtasks,
        retryCallback,
    } = useTaskViewState(payload, isDragPreview);

    if (errorType != undefined && errorType !== AssetErrorType.NotFound) {
        return (
            <AssetError assetType={'task'} errorType={errorType} retryCallback={retryCallback} />
        );
    }

    return (
        <div className={styles.taskView}>
            <div className={styles.dueDateContainer}>{DueDate}</div>
            <div className={styles.taskAsset}>
                <div className={styles.completionWrapper}>
                    <TaskViewCompletion
                        taskId={taskId}
                        taskSubject={taskSubject}
                        isComplete={isTaskComplete}
                    />
                </div>
                <TaskViewTitle
                    hasLocalSubject={hasLocalTaskSubject}
                    newSubtaskRef={newSubtaskRef}
                    folderId={folderId}
                    taskId={taskId}
                    taskSubject={taskSubject}
                    isComplete={isTaskComplete}
                />
            </div>
            {errorType === AssetErrorType.NotFound ? (
                <div className={styles.errorContainer}>
                    <AssetErrorNotFound />
                </div>
            ) : (
                <SubTasksView
                    newSubtaskRef={newSubtaskRef}
                    taskId={taskId}
                    subtasks={subtasks}
                    disableSubtasks={disableSubtasks}
                />
            )}
        </div>
    );
});
